import ConfirmModal from '@/components/Modal/ConfirmModal/ConfirmModal';

import useConfirmModal from './hooks/useConfirmModal';

/**
 * The app's confirm-modal mount point: the one place the `confirmModalState`
 * atom is rendered. Every producer (`useAsSource`'s duplicate warning,
 * `useDownload`'s batched failure) writes the atom through `useConfirmModal`
 * and never renders a modal of its own.
 *
 * It is mounted once per page, not once per app, because CvcPage needs it
 * INLINE (`isPortal={false}`) — `StyledCvcContent` styles `.confirm-modal` as
 * a descendant. MssPage renders `useDownload` too, so it mounts the same
 * component in its default portalled form; without that mount, an MSS download
 * failure would set the atom and show nothing. The two pages are separate
 * routes and never mount together.
 */
const AppConfirmModal = ({ isPortal }: { isPortal?: boolean }) => {
  const { confirmModalState, closeConfirmModal } = useConfirmModal();

  return (
    <ConfirmModal
      isPortal={isPortal}
      className="confirm-modal"
      {...confirmModalState}
      onConfirm={() => {
        confirmModalState.onConfirm?.();
        closeConfirmModal();
      }}
      onCancel={() => {
        confirmModalState.onCancel?.();
        closeConfirmModal();
      }}
    />
  );
};

export default AppConfirmModal;
